<form [formGroup]="form">
  <ion-row>
    <ion-col size="7">
      <ion-radio-group formControlName="cvisHardware" class="radio-group">
        <ion-radio class="radio-btn" [labelPlacement]="'end'" [value]="true">
          {{ CONSTANTS.HARDWARE }}
        </ion-radio>
        <ion-radio class="radio-btn" [labelPlacement]="'end'" [value]="false">
          {{ CONSTANTS.NO_HARDWARE }}
        </ion-radio>
      </ion-radio-group>
    </ion-col>
  </ion-row>
  @if (form.get("cvisHardware")?.value === false) {
    <ion-row>
      <ion-col size="7" push="3">
        <div class="dropdown-container">
          <ng-select
            class="dropdown"
            appearance="outline"
            formControlName="cvisIterations"
            [searchable]="false"
            [clearable]="false"
          >
            @for (option of OPTIONS; track option) {
              <ng-option class="selected-icon" [value]="option.value">
                <div class="option">
                  {{ option.label }}
                </div>
              </ng-option>
            }
          </ng-select>
          <div>{{ CONSTANTS.DROPDOWN_LABEL }}</div>
        </div>
      </ion-col>
    </ion-row>
  }
</form>
